import { Level2, Level3 } from '../StyledOl';

const GeneralWarrenties = () => (
  <li>
    GENERAL WARRANTIES
    <Level2>
      <li>
        Without prejudice to any implied warranty, conditions or other terms, or any duty at common
        law, the Contractor warrants that the Goods and/or Services supplied:
        <Level3>
          <li>is free from defects in material and workmanship and fit for its purpose;</li>
          <li>
            includes the scope of work and items agreed by the Parties as set out in the
            Specifications;
          </li>
          <li>conforms to all standards, specifications or descriptions agreed by the Parties;</li>
          <li>
            shall comply with all applicable international, federal, state and local laws, rules and
            regulations (including, without limitation, those concerning health, safety, and
            environmental standards) which bear upon the Contractor&rsquo;s performance;
          </li>
          <li>
            shall be brand new and not refurbished or reconditioned, unless expressly agreed in
            writing by LINK, and
          </li>
          <li>
            is not restricted for usage by LINK in any way by any pre-existing patents, copyrights,
            mask work, trademark, trade secrets, or intellectual property, proprietary or
            contractual right of any third party.
          </li>
        </Level3>
      </li>
      <li>
        The Goods and/or Service supplied is subject to inspection and testing (where appropriate)
        by LINK at any time and place.
      </li>
      <li>
        In addition to and without prejudice to any other rights of LINK under this Purchase Order,
        in the event the Contractor fails to deliver the Goods and/or Service or perform the
        Services in accordance with the agreed timelines or any part of the Goods and/or Service
        furnished are found to be damaged, defective or otherwise fail to conform to the
        specifications in this Purchase Order, LINK may in its absolute discretion:
        <Level3>
          <li>
            reject the Goods and/or Service in whole or in part and require the Contractor to remove
            or replace or completely repair the defective parts of Goods or otherwise completely
            rectify all defects to the Goods and/or Service or make good the damage or carry out
            such other corrective action as may be required to enable the Goods to conform to the
            specifications in this Purchase Order, to LINK&rsquo;s satisfaction, without charge:
          </li>
          <li>require a reduction in price which is equitable under the circumstances;</li>
          <li>undertake itself to any repair at the expense and risk of the Contractor; or</li>
          <li>claim any damages caused by defects.</li>
        </Level3>
      </li>
      <li>
        If the Contractor is unable or refuses to comply with its obligations within a time deemed
        reasonable by LINK, LINK may terminate this Purchase Order in whole or in part and/or
        purchase the replacements for the Goods and/or Service elsewhere or rectify or make good any
        defects or damage in any manner it deems necessary, including but not limited to having
        defects rectified by other contractors. The Contractor agrees to bear all costs, losses and
        expenses so incurred by LINK and such costs, losses and expenses may be deducted from any
        money due to the Contractor under this Purchase Order. During the waiting period for the
        Goods to be replaced, repaired or remedied or during the waiting period of re-performance of
        Services, or replacement of deliveries, LINK shall have the right to charge daily interest
        at a rate of 0.1%, for each day there is an outstanding replacement, repaired or remedied
        Goods which has not be delivered to the Site. In addition, the expense of transportation of
        the Goods to the location of and from the location of repair to the intended Site, the
        Contractor agrees to absorb all risk and cost involved.
      </li>
    </Level2>
  </li>
);

export default GeneralWarrenties;
